export default __webpack_public_path__ + "09cdefebe28ca1969e90c6b5210ce9ba.png";